import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './state/store';
import { checkAuth } from './state/authSlice';
import RoutesComponent from './RoutesComponent';
import Sidebar from './components/Sidebar/Sidebar';
import './App.css';

const App: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  console.log('from my app', isAuthenticated);

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  return (
    <main className="all">
      <Router>
        {isAuthenticated && (
          <div className="sidebar">
            <Sidebar />
          </div>
        )}
        <div className="others">
          <RoutesComponent isAuthenticated={isAuthenticated} />
        </div>
      </Router>
    </main>
  );
};

export default App;
